import Download from 'assets/download.svg?react'
import Trash from 'assets/trash.svg?react'
import { ArrowRightIcon, PencilIcon, X } from 'lucide-react'
import styled from 'styled-components'

export const DownloadIcon = styled(Download)`
  width: 1rem;
  height: 1rem;
  margin-left: 0.25rem;
  margin-right: 0.25rem;
`

export const StyledTrashIcon = styled(Trash)`
  width: 1rem;
  height: 1rem;
  margin-left: 0.25rem;
  margin-right: 0.25rem;
`

export const StyledPencilIcon = styled(PencilIcon)`
  width: 1rem;
  height: 1rem;
  margin-left: 0.25rem;
  margin-right: 0.25rem;
`

export const StyledArrowRightIcon = styled(ArrowRightIcon)`
  width: 1rem;
  height: 1rem;
  margin-left: 0.25rem;
  margin-right: 0.25rem;
`

export const StyledCloseIcon = styled(X)`
  height: 1rem;
  width: 1rem;
`

export const StyledInput = styled.input`
  border-radius: 0.25rem;
  border-color: transparent;
  border-width: 0;
  color: ${({ theme }) => theme.forecast.defaultText};
  background-color: ${({ theme }) => theme.forecast.cardGroupBackground};
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.25rem;

  &::placeholder {
    color: ${({ theme }) => theme.forecast.secondaryText};
  }

  &[type='date']:focus,
  &[type='date']:focus-visible {
    outline: 2px solid ${({ theme }) => theme.forecast.border};
    outline-offset: 2px;
  }
`

export const MultiSelectInput = styled(StyledInput)`
  appearance: none;
  -webkit-appearance: none;
  display: inline-grid;
  place-content: center;
  width: 1rem;
  height: 1rem;
  min-width: 1rem;
  margin: 0;
  padding: 0;
  cursor: pointer;
  border: 1.5px solid ${({ theme }) => theme.forecast.defaultText};
  border-radius: 0.25rem;
  background-color: transparent;

  &::after {
    content: '';
    width: 0.3rem;
    height: 0.55rem;
    border: solid ${({ theme }) => theme.forecast.activeText};
    border-width: 0 2px 2px 0;
    transform: rotate(45deg) translateY(-1px);
    opacity: 0;
  }

  &:checked {
    border-color: ${({ theme }) => theme.forecast.primary};
    background-color: ${({ theme }) => theme.forecast.primary};
  }

  &:checked::after {
    opacity: 1;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.forecast.border};
    outline-offset: 2px;
  }
`

export const StyledLabel = styled.label`
  display: flex;
  align-items: flex-start;
  min-width: 4rem;
  color: ${({ theme }) => theme.forecast.defaultText};
  font-weight: 500;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.25rem;
  padding: 0 0.25rem;
`

export const LabelAndInputContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.25rem;
  width: max-content;
`

export const RelativeWrap = styled.div`
  position: relative;
  z-index: 10;
`

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  margin-top: 0.25rem;
  min-height: 2.5rem;
  padding: 0.25rem 0.5rem;
  justify-content: flex-start;
  justify-content: center;
  gap: 0.5rem;
  align-self: stretch;
  border-radius: 0.25rem;
  background-color: ${({ theme }) => theme.forecast.glassBackground};
  backdrop-filter: blur(2rem);
  box-shadow:
    0 0.063rem 0.125rem 0 rgba(0, 0, 0, 0.1),
    0 0.25rem 0.5rem 0 rgba(0, 0, 0, 0.1);
  -webkit-backdrop-filter: blur(2rem);
`
